<template>
  <div
    class="instagram-modules"
    :class="{ container: !wild_screen, }"
    v-if="post_data.length"
  >
    <div class="ins-head text-center">
      <h5>{{ module_data.module_title }}</h5>
      <p v-if="module_data.module_description">
        {{ module_data.module_description }}
      </p>
    </div>
    <div
      class="ins-content"
      :class="{ not_swiper: layout_type == 'grid', no_spacing: no_spacing }"
      v-if="post_data.length"
    >
      <v-customSwiper
        :total_num="post_data.length"
        :page_num="row_amount"
        :mb_page_num="1"
        :mb_show_sides="true"
        :not_swiper="layout_type == 'grid'"
        :touchScroll="true"
        button_type="welt"
      >
        <div class="ins-list-box">
          <div
            class="ins-list-card"
            v-for="(item, index) in post_data"
            :key="item.id + item.out_id + index"
            @click.stop="show_model(index)"
          >
            <div class="ins-card">
              <v-imageCard
                :data_url="item.media && item.media.url"
                img_type="cover"
              ></v-imageCard>
              <div class="ins-overlay">
                <div class="overlay-main">
                  <span class="iconfont icon-cm-instagram"></span>
                  <p
                    class="ins-btn"
                    v-if="
                      messages_button_title &&
                      item.instagram_products &&
                      item.instagram_products.length
                    "
                  >
                    <span>{{ messages_button_title }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-customSwiper>
    </div>
    <v-insModel
      v-if="
        post_data &&
        post_data.length &&
        post_data[ins_post_index]
      "
      v-show="
        post_data &&
        post_data.length &&
        post_data[ins_post_index] &&
        model_on_off
      "
      :ins_post="post_data[ins_post_index]"
      :post_data_length="post_data.length"
      :ins_post_index="ins_post_index"
      :prev_method="prev_method"
      :next_method="next_method"
      :theme="theme"
      :cart_type="cart_type"
      :hide_model="hide_model"
      :ins_user_name="module_data.ins_user_name"
      :button_title="button_title"
      :background_color="background_color"
      :text_color="text_color"
      :show_product_model="show_product_model"
      :add_cart="add_cart"
    ></v-insModel>

    <!-- 商品详情弹窗 -->
    <v-productDetail
      v-if="product"
      v-show="product_model_on_off && product"
      :product="product"
      :add_cart="add_cart"
      buy_able_class="main_button"
      model="instagram"
      :isPC="isPC"
      :hide_product_model="hide_product_model"
      select_style="all"
      :theme="theme"
      :disabled="disabled"
    ></v-productDetail>
  </div>
</template>
<script>
// import API from "../../../API";
import vCustomSwiper from "../../common/customSwiper.vue";
import vImageCard from "../../common/imgCard.vue";
import vInsModel from "./insModel.vue";
import vProductDetail from "../../common/productDetail.vue";
import googleAnalysis from "@/js/lib/ga";
export default {
  props: ["theme", "cart_type", "ins_config", "ids", "mobile_mode"], //mobile_mode athena主题移动端要ins一列要显示1.5个
  data() {
    return {
      module_data: {},
      post_data: [],
      model_on_off: false,
      product_model_on_off: false,
      ins_post: {},
      ins_post_index: 0,
      instagram_id: null, //ins模块id
      layout_type: "slide", //滑块,网格
      limit_count: "20", //限制最大数量
      row_amount: 3, //每行显示数量
      no_spacing: false, //无间距模式
      button_title: null, //按钮文本
      wild_screen: false, //ins宽屏
      background_color: null, // 按钮背景颜色
      text_color: null, // 按钮字体颜色
      messages_button_title: null, // 查看帖子按钮
      isPC: !navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      ),
      product: {},
      disabled: false,
    };
  },
  async beforeMount() {
    try {
      if(!this.instagram_id) return
      let params = {
        module_id: this.instagram_id,
        post_num: this.limit_count,
        product_ids: this.ids ? [...this.ids] : [],
      };
      let res = await this.$axios.get(API.get_instagram, { params });
      if (res && res.data && res.data.data) {
        let { module_data, post_data } = res.data.data;
        this.module_data = module_data;
        this.post_data = [...post_data];
      }
      if (this.post_data.length) {
        this.$nextTick(() => {
          this.$el.style.setProperty(
            "--post-pc-num",
            100 / this.row_amount + "%"
          );
        });
      }
    } catch (error) {}
  },
  methods: {
    async add_cart(payload, variant) {
      try {
        this.disabled = true;
        this.$store.dispatch("change_button_disabled", true);
        let res = await this.$axios.post(API.addcart, {...payload,addType:'instagram'});
        if (window.fbq) {
          let content_category = [];
          if (variant.categories && variant.categories.length) {
            variant.categories.forEach((item) => {
              content_category.push(item.name);
            });
          }
          this.send_fb_event("AddToCart", {
            content_type: "product_group",
            content_ids: [payload.product_id],
            value: variant.price,
            num_items: payload.quantity,
            content_name: variant.title,
            currency: res.data.currency ? res.data.currency : "USD",
            content_category,
          });
        }
        if (window.ttq && window.send_ttp_event) {
          window.send_ttp_event('AddToCart', {
            content_id: [payload.product_id],
            quantity: payload.quantity,
            value: variant.price,
            currency: window.checkoutcurrency || 'USD',
          })
        }
        if (window._learnq) {
          this.klaviyo_addtocart(variant, payload);
        }
        // if (window.gtag) {
        //   window.gtag("event", "add_to_cart");
        // }
        // 添加到购物车
        googleAnalysis.event(googleAnalysis.gaAction.add);

        this.$store.dispatch("change_news_cart", res.data);
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
        this.active = false;
        if (
          (this.theme == "Brooklyn" || this.theme == "showtime") &&
          this.cart_type == "drawer"
        ) {
          if (this.theme == "Brooklyn") {
            this.$store.dispatch("change_cart_type", true);
          }
          if (this.theme == "showtime") {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            this.$("#collapseExample").collapse("show");
          }
        } else if (
          (this.theme == "venue" || this.theme == "showtime") &&
          this.cart_type == "popup"
        ) {
          this.$("#modalCart").modal("show");
        } else if (
          this.theme == "vogue" &&
          (this.cart_type == "drawer" || this.cart_type == "popup")
        ) {
          this.showInlineCart();
        } else {
          window.open("/cart", "_self");
        }
      } catch (error) {
        this.disabled = false;
        this.$store.dispatch("change_button_disabled", false);
        if (
          error?.response?.data?.errors
        ) {
          this.$message.error(Object.values(error.response.data.errors)[0][0]);
        } else if (error?.response?.data?.message) {
          this.$message.error(error.response.data.message);
        }
      }
    },
    hide_some_product() {},
    shou_some_product() {},
    prev_method() {
      if (this.ins_post_index > 0) {
        this.ins_post_index--;
      }
    },
    next_method() {
      if (this.ins_post_index < this.post_data.length) {
        this.ins_post_index++;
      }
    },
    hide_model() {
      this.$("body").css({ overflowY: "auto" });
      this.model_on_off = false;
    },
    show_model(index) {
      this.$("body").css({ overflowY: "hidden" });
      this.ins_post_index = index;
      this.model_on_off = true;
    },
    hide_product_model() {
      this.product_model_on_off = false;
      this.$(".ins-model-main").removeClass("ins-model-main_transform");
      this.product = undefined;
    },
    show_product_model(products) {
      this.$(".ins-model-main").addClass("ins-model-main_transform");
      this.product_model_on_off = true;
      this.product = products;
    },
  },
  watch: {
    ins_config: {
      handler(newV) {
        let {
          instagram_id,
          layout_type,
          limit_count,
          no_spacing,
          row_amount,
          button_title,
          wild_screen,
          background_color,
          text_color,
          messages_button_title,
        } = newV;
        this.instagram_id = instagram_id;
        this.layout_type = layout_type;
        this.limit_count = limit_count;
        this.no_spacing = no_spacing;
        this.row_amount = row_amount;
        this.button_title = button_title;
        this.wild_screen = wild_screen;
        this.background_color = background_color;
        this.text_color = text_color;
        this.messages_button_title = messages_button_title;
      },
      immediate: true,
      deep: true,
    },
  },
  components: {
    vCustomSwiper,
    vImageCard,
    vInsModel,
    vProductDetail,
  },
};
</script>
<style scoped lang='scss'>
.instagram-modules {
  margin-top: 40px;
  .ins-head {
    h5 {
      font-size: 30px;
      font-weight: 600;
      color: #333333;
      line-height: 1;
    }
    p {
      line-height: 1;
      font-size: 14px;
      font-weight: 400;
      margin: 14px 0 0;
    }
    margin-bottom: 40px;
  }
  .ins-content {
    margin-left: -10px;
    margin-right: -10px;
    margin-bottom: 80px;
    .ins-list-box {
      display: flex;
      flex-wrap: nowrap;
      .ins-list-card {
        width: var(--post-pc-num);
        max-width: var(--post-pc-num);
        min-width: var(--post-pc-num);
        padding: 0 15px;
        .ins-card {
          width: 100%;
          position: relative;
          cursor: pointer;
          .imgCard {
            display: block;
          }
          &:hover {
            .ins-overlay {
              display: flex;
              align-items: center;
            }
          }
          .ins-overlay {
            display: none;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            text-align: center;
            background-color: rgba($color: #000000, $alpha: 0.2);
            color: white;
            .overlay-main {
              width: 100%;
              .icon-cm-instagram {
                font-size: 20px;
              }
              .ins-btn {
                margin-top: 12px;
                span {
                  display: inline-block;
                  width: auto;
                  padding: 4px 12px;
                  font-weight: 600;
                  line-height: 20px;
                  border-radius: 8px;
                  border: 2px solid #ffffff;
                }
              }
            }
          }
        }
      }
    }
  }
  .not_swiper {
    .ins-list-box {
      flex-wrap: wrap;
      .ins-list-card {
        padding: 10px;
      }
    }
  }
  .no_spacing {
    margin-left: 0;
    margin-right: 0;
    .ins-list-box {
      .ins-list-card {
        padding: 0 !important;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .instagram-modules {
    margin-top: 40px;
    .ins-head {
      margin-bottom: 24px;
      h5 {
        margin-bottom: 0;
        font-size: 18px;
      }
    }
    .ins-content {
      margin-bottom: 40px;
      .ins-list-box {
        .ins-list-card {
          width: 100%;
          max-width: 100%;
          min-width: 100%;
          padding: 0 6px;
        }
      }
    }
    .not_swiper {
      .ins-list-box {
        flex-wrap: wrap;
        .ins-list-card {
          width: 50%;
          max-width: 50%;
          min-width: 50%;
          padding: 5px;
        }
      }
    }
  }
  .one_half {
    .ins-content {
      .ins-list-box {
        .ins-list-card {
          width: 79%;
          max-width: 79%;
          min-width: 79%;
          padding: 0 7.5px;
        }
      }
      &::v-deep .custom-swiper-wrap .custom-swiper {
        padding-left: 7.5px !important;
        padding-right: 7.5px !important;
      }
    }
  }
}
</style>
